import { render, staticRenderFns } from "./ReleaseDistributionLinkCoppier.vue?vue&type=template&id=15d62e2a&"
import script from "./ReleaseDistributionLinkCoppier.vue?vue&type=script&lang=js&"
export * from "./ReleaseDistributionLinkCoppier.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDistributionLinkCoppier.vue?vue&type=style&index=0&id=15d62e2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports